import { ARC_SERVICE } from "@/utils/services";
import { UUID_SEGMENT_PATTERN } from "@/constants/regex";

export const mspRoutes = {
  path: `/msp/:orgUuid(${UUID_SEGMENT_PATTERN})`,
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "email_archiving",
      name: "msp-arc_titan",
      component: () => import("@/modules/ArcTitan/Views/Common"),
      meta: {
        solutionId: ARC_SERVICE,
      },
    },
  ],
};

export default {};
